import axios from '../utils/axios';

export default function fetchFilters(adminId, recruiterId, jobId, params) {
    return (
        axios.get('/admin/' + adminId + '/recruiter/' + recruiterId + '/jobs/' + jobId + '/filters', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
